interface StorageData {
  state: Record<string, unknown>;
  version: number;
}

export function updateSessionStorageState(storageKey: string, updater: (state: Record<string, unknown>) => void): void {
  const currentStorage = sessionStorage.getItem(storageKey);
  let storageData: StorageData;

  try {
    storageData = currentStorage ? JSON.parse(currentStorage) : { state: {}, version: 0 };
  } catch {
    storageData = { state: {}, version: 0 };
  }

  updater(storageData.state);
  sessionStorage.setItem(storageKey, JSON.stringify(storageData));
}
